let language = {
    ORDER_DETAIL_DESCRIPTION: "Item Description",
    ORDER_DETAIL_QUANTITY: "Quantity",
    ORDER_DETAIL_UNIT: "Unit Price",
    ORDER_DETAIL_AMOUNT: "Line Amount",
    ORDER_DETAIL_OPERATION: "Operation",
    ORDER_DETAIL_PREVIEW: "PREVIEW",
    ORDER_DETAIL_NAME: "Name",
    ORDER_DETAIL_SKU: "SKU",
    ORDER_DETAIL_EDIT: "Edit",
    ORDER_DETAIL_RETURN: "Return",
    ORDER_DETAIL_COUNT_1: "You can pay this order in",
    ORDER_DETAIL_COUNT_2: "second.",
    ORDER_DETAIL_COUNT_3: "minutes.",
    ORDER_DETAIL_SUBTOTAL: "Subtotal",
    ORDER_DETAIL_TITLE_SHIPPING: "Shipping",
    ORDER_DETAIL_TAX: "Tax",
    ORDER_DETAIL_IMPORT_SERVICE_FEE: "Import Service",
    ORDER_DETAIL_TOTAL: "Total Due",
    ORDER_DETAIL_CONTINUE_PAY: "Continue to Pay",
    ORDER_DETAIL_CONTINUE_BACK: "BACK",
    ORDER_DETAIL_PRODUCT_INFORMATION: "Product Information",
}

export { language }